import styled from "styled-components";
import { BORDER_RADIUS, SPACING } from "../../constants/design/spacing";
import {
  COLORS,
  LAYER_COLORS,
  TEXT_COLORS,
} from "../../constants/design/colors";
import { FONT_CSS } from "../../constants/design/fontSize";

export const NetworkButtonsContainer = styled.div`
  display: grid;
  /* Equal columns that never size-to-content, so a long chain name can't widen a
     column and push the grid past the narrow (~310px) deposit/switch modals. */
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-gap: ${SPACING.two}px;
  margin-top: ${SPACING.two}px;
  margin-bottom: ${SPACING.three}px;
`;

export const NetworkButton = styled.button.attrs({
  type: "button",
})<{ isSelected?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: ${LAYER_COLORS.two};
  border-radius: ${BORDER_RADIUS.five}px;
  transition: 0.2s all ease-in-out;
  /* Grow for multi-word chain names ("Monad Testnet", "Basecamp Testnet") that
     wrap to two lines instead of clipping a fixed height. */
  min-height: 64px;
  min-width: 0;
  padding: ${SPACING.two}px ${SPACING.one}px;
  ${FONT_CSS.body.five}
  line-height: 1.2;
  overflow-wrap: anywhere;
  border: 1px solid ${({ isSelected }) =>
    isSelected ? COLORS.highlight.one : "transparent"};
  color: ${({ isSelected }) =>
    isSelected ? TEXT_COLORS.one : TEXT_COLORS.two};

  svg {
    width: 32px;
    height: 32px;
    margin-bottom: ${SPACING.one}px;
    flex-shrink: 0;
  }
`;
